import { apiProxyRequest } from "Api/apiProxyRequest";

import type { EstimationProject } from "../types";

export const getProjectEstimates = ({
  billingProfileId,
  projectId,
  param
}: {
  billingProfileId: string;
  projectId: string;
  param: string;
}) => {
  return apiProxyRequest<EstimationProject>(
    `/billing/profiles/${billingProfileId}/projects/${projectId}/estimate${param}`
  );
};
